import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Chart } from 'chart.js';
import { AlertHelper } from 'src/app/shared/components/helpers/alert.helpers';
import { Previsional } from 'src/app/shared/models/previsonal';
import ChartDataLabels from 'chartjs-plugin-datalabels';

@Component({
  selector: 'app-indicadores-previsionales',
  templateUrl: './indicadores-previsionales.component.html',
  styleUrls: ['./indicadores-previsionales.component.css']
})
export class IndicadoresPrevisionalesComponent implements OnInit, OnDestroy {
  intentosFetchPrevired: number = 0;
  previsional:Previsional;
  loading: boolean = true;
  chart: any | undefined;
  @ViewChild('barCanvas', { static: false }) barCanvas!: ElementRef;

  constructor(
    private alert: AlertHelper,
    private cdRef: ChangeDetectorRef
  ) { }


  ngOnInit(): void {
    this.cargarDatosPrevisionales();
  }

  initBarChart() {
    if (!this.barCanvas) {
      console.warn('barCanvas no está disponible aún');
      return;
    }
    const ctx = this.barCanvas.nativeElement.getContext('2d');
    const tasas = [
      parseFloat(this.previsional.AFPCapitalTasaDepAct.replace(',', '.')),
      parseFloat(this.previsional.AFPCuprumTasaDepAct.replace(',', '.')),
      parseFloat(this.previsional.AFPHabitatTasaDepAct.replace(',', '.')),
      parseFloat(this.previsional.AFPPlanVitalTasaDepAct.replace(',', '.')),
      parseFloat(this.previsional.AFPProVidaTasaDepAct.replace(',', '.')),
      parseFloat(this.previsional.AFPModeloTasaDepAct.replace(',', '.')),
      parseFloat(this.previsional.AFPUnoTasaDepAct.replace(',', '.'))
    ];

    const labels = ['Capital', 'Cuprum', 'Habitat', 'PlanVital', 'ProVida', 'Modelo', 'Uno'];

    this.chart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [{
          label: 'Tasa de Cotización (%)',
          data: tasas,
          backgroundColor: [
            '#ffe3e9',
            '#def1ff',
            '#fff6e0',
            '#e3ffff',
            '#f2ecff',
            '#ffefe0',
            '#d9f6f0'
          ],
          borderColor: [
            '#ff9fb3',
            '#30abff',
            '#ffcb4d',
            '#49d9d9',
            '#ab81ff',
            '#FF9F40',
            '#00C49F'
          ],
          borderWidth: 1
        }]
      },
      options: {
        responsive: true,
        plugins: {
          datalabels: {
            color: '#333',
            anchor: 'end',
            align: 'start',
            formatter: function (value) {
              return value.toFixed(2) + ' %';
            },
            font: {
              weight: 'normal'
            }
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            title: {
              display: true,
              text: 'Tasa (%)',
            }
          }
        }
      },
      plugins: [ChartDataLabels]
    });
  }

  // Obtiene los datos previsionales
  cargarDatosPrevisionales(){
    const hoy = new Date();
    const mes = hoy.getMonth() + 1;
    const anio = hoy.getFullYear();
    this.obtenerFetchPrevisional(mes, anio);
  }

  async obtenerFetchPrevisional(mes: number, year: number) {
    this.intentosFetchPrevired++;
    const month = mes < 10 ? '0' + mes : mes.toString();
    const data = await this.cargarDatosPrevired(month, year);

    if (!data.message) {
      this.previsional = data;
      this.previsional.UFValPeriodoAnt = this.previsional.UFValPeriodoAnt.replace(',', '.');
      this.previsional.UFValPeriodo = this.previsional.UFValPeriodo.replace(',', '.');

      // Espera a que Angular actualice la vista y renderice el canvas
      this.cdRef.detectChanges();

      // Ahora sí es seguro inicializar el gráfico
      this.initBarChart();
    } else {
      if (this.intentosFetchPrevired > 1) {
        this.intentosFetchPrevired = 0;
        this.alert.errorAlert('Al parecer hay algún error de conexión de internet o con los datos.');
      } else {
        mes = mes - 1 === 0 ? 12 : mes - 1;
        year = mes - 1 === 0 ? year - 1 : year;
        this.obtenerFetchPrevisional(mes, year);
      }
    }
  }


  async cargarDatosPrevired(month: string, year: number): Promise<any> {
    return new Promise((resolve, reject) => {
      setTimeout(async () => {
        const result = await fetch('https://api.gael.cloud/general/public/previred/'+month+year);
        console.log(result);
        const data = await result.json();
        console.log("data previred: ", data);
        resolve(data);
      }, 2000);
    })
  }

  ngOnDestroy() {
    if (this.chart) {
      this.chart?.destroy();
    }
  }

  goToPrevired() {
    window.open('https://www.previred.com/indicadores-previsionales/', '_blank');
  }


}
